import React from 'react';
import { Row, Col, DatePicker, Select } from 'antd';
import BaseDailyPage from '../../common/baseDailyPage';
import Header from '../../common/dailyHeader';
import MembersWidget from './members.js';
import PointsEarnedWidget from './pointsEarned.js';
import OvercomingWidget from './overcoming.js';
import GuestCardActivitiesWidget from './guestCardActivities.js';
import GoalsAndAveragesWidget from './goalsAndAverages.js';
import FastingWidget from './fasting.js';
import PrayingWidget from './praying.js';
import GroupPerformanceWidget from './groupPerformance.js';
import WidgetContainer from '../../common/widgetContainer';
import { revivalPhaseCountdown } from "../../../../../utilities/churchRevival";

export default class DailyPage extends BaseDailyPage {
  componentWillMount() {
    super.componentWillMount();

    if(!this.groupIdFromUrl) {
      this.setQueryParam('groupId', this.props.selectedChurchGroups[0].id);
    }
  }

  get widgetParams() {
    return {
      churchId: this.props.selectedChurch.id,
      churchGroupId: parseInt(this.groupIdFromUrl, 10),
      timezone: this.props.selectedChurch.timezone,
      periodStartTime: this.periodStartDate.unix(),
      periodEndTime: this.periodEndDate.unix()
    }
  }

  get groupIdFromUrl() {
    const query = new URLSearchParams(this.props.history.location.search);
    return query.get('groupId');
  }

  getGroupSelectFilterOptions(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  onGroupChange = (value) => {
    this.setQueryParam('groupId', value);
  };

  get header() {
    return (
      <Row className="statistics-page-header-row">
        <Col size={24} className="statistics-page-header-with-filter">
          <div className="statistics-page-header">
            <Header churchId={this.props.selectedChurch.id}
                    periodStartTime={this.periodStartDate.unix()}
                    periodEndTime={this.periodEndDate.unix()}
                    revivalStartDate={this.props.revivalWeeks.church.revival.startDate}/>
          </div>
          <Select showSearch style={{ width: 250 }} placeholder="Select a group" optionFilterProp="children"
                  onChange={this.onGroupChange} filterOption={this.getGroupSelectFilterOptions}
                  value={this.groupIdFromUrl}>
            {
              this.props.selectedChurchGroups.map(group => {
                return (
                  <Select.Option key={`church_group_id_${group.id}`} value={`${group.id}`}>
                    {group.name}
                  </Select.Option>
                );
              })
            }
          </Select>
          <DatePicker disabledDate={this.disabledDate} value={this.periodStartDate}
                      onChange={this.onDayChange} format={this.dateFormat}/>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <WidgetContainer header={this.header}>
        <MembersWidget {...this.widgetParams} position={{ xl: 0, lg: 0, md: 0 }} />
        <PointsEarnedWidget {...this.widgetParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <OvercomingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <GuestCardActivitiesWidget {...this.widgetParams} position={{ xl: 0, lg: 1, md: 0 }} />
        <GoalsAndAveragesWidget {...this.widgetParams} position={{ xl: 1, lg: 1, md: 0 }} />
        <FastingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <PrayingWidget {...this.widgetParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <GroupPerformanceWidget {...this.widgetParams} position={{ xl: 2, lg: 1, md: 0 }} />
      </WidgetContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/daily/daily.js